import {
    ChannelControlPlugin,
    DiscreteAudioPlugin,
    VttSubtitlePlugin,
    SmoothTimeUpdateEventType,
    SmoothTimeUpdateEvent,
    SmoothTimeUpdatePlugin,
} from '@accurate-player/accurate-player-plugins';
import wrap from 'wraptile';
import {
    ApTimelineMetadata,
    ApTimelineMarker,
    ApTooltip,
} from '@accurate-player/accurate-player-components-external';
import {Player, PlayerStatusChangedEvent, PlayerEventType} from '@accurate-player/accurate-player-core';

export type ChannelControlPluginOrNull = ChannelControlPlugin | null;
export type DiscreteAudioPluginOrNull = DiscreteAudioPlugin | null;
export type VttSubtitlePluginOrNull = VttSubtitlePlugin | null;

export const ifChannelControlPlugin = wrap((fn: Function, plugin: ChannelControlPluginOrNull, ...args: any[]) => {
    if (!plugin)
        return;
    
    fn(...args);
});

export const ifNotChannelControlPlugin = wrap((fn: Function, plugin: ChannelControlPluginOrNull, ...args: any[]) => {
    if (plugin)
        return;
    
    fn(...args);
});

export const ifNotDiscreteAudioPlugin = wrap((fn: Function, plugin: DiscreteAudioPluginOrNull, ...args: any[]) => {
    if (plugin)
        return;
    
    fn(...args);
});

export const ifSubtitlePlugin = wrap((fn: Function, plugin: VttSubtitlePluginOrNull, ...args: any[]) => {
    if (!plugin)
        return;
    
    fn(...args);
});

export const ifApTimelineMetadata = wrap((fn: Function, node: ApTimelineMetadata, ...args: any[]) => {
    if (!node)
        return;
    
    fn(...args);
});

export const ifApTimelineMarker = wrap((fn: Function, node: ApTimelineMarker, ...args: any[]) => {
    if (!node)
        return;
    
    fn(...args);
});

export const ifApTooltip = wrap((fn: Function, node: ApTooltip, ...args: any[]) => {
    if (!node)
        return;
    
    fn(...args);
});

export const addPlayerListenerWhilePause = (player: Player, cleanupFn: any): (event: PlayerStatusChangedEvent) => void => {
    const handlePlayerStatusChange = (event: PlayerStatusChangedEvent) => {
        if (event.status.paused)
            return;
        
        cleanupFn();
        player.removeEventListener(PlayerEventType.StatusChanged, handlePlayerStatusChange);
    };
    
    player.addEventListener(PlayerEventType.StatusChanged, handlePlayerStatusChange);
    
    return handlePlayerStatusChange;
};

export const addPlayerListenerWhilePlay = (player: Player, cleanupFn: any): (event: PlayerEventType.UserPause) => void => {
    const handlePlayerPausedByUser = () => {
        cleanupFn();
        player.removeEventListener(PlayerEventType.UserPause, handlePlayerPausedByUser);
    };
    
    player.addEventListener(PlayerEventType.UserPause, handlePlayerPausedByUser);
    
    return handlePlayerPausedByUser;
};

export const addPlayerListenerWhileDefaultPlaybackrate = (player: Player, cleanupFn: any): (event: PlayerStatusChangedEvent) => void => {
    const handlePlayerStatusChange = (event: PlayerStatusChangedEvent) => {
        if (event.status.playbackRate === 1)
            return;
        
        cleanupFn();
        player.removeEventListener(PlayerEventType.StatusChanged, handlePlayerStatusChange);
    };
    
    player.addEventListener(PlayerEventType.StatusChanged, handlePlayerStatusChange);
    
    return handlePlayerStatusChange;
};

export const addSmoothPluginListenerUntilFrame = (plugin: SmoothTimeUpdatePlugin, frame: number, cleanupFn: any): (event: SmoothTimeUpdateEvent) => void => {
    const handleTimeUpdate = (event: SmoothTimeUpdateEvent) => {
        if (event.currentFrame !== frame)
            return;
        
        cleanupFn();
        plugin.removeEventListener(SmoothTimeUpdateEventType.TimeUpdate, handleTimeUpdate);
    };
    
    plugin.addEventListener(SmoothTimeUpdateEventType.TimeUpdate, handleTimeUpdate);
    
    return handleTimeUpdate;
};
